import permissions from 'src/data/permissions.json';
import { CTMSUI } from 'src/types/KeyCloak';
import { useUser } from './useUser';

export const usePermissionWrapper = () => {
  const { roles } = useUser();
  const checkPermission = (access: string) => {
    const found = permissions.access.find(item => item.key === access);
    return found && roles.includes(found.permission as CTMSUI);
  };
  return { checkPermission };
};
